// Адрес бота поддержки нужен фронту (ссылка и tg://-схема) и бэку (deep-link с токеном). Вторая
// строка с именем бота разошлась бы с первой при переезде инбокса, и ссылка вела бы в пустоту.
export const SUPPORT_TELEGRAM_BOT_USERNAME: string = 'lumirphoto_bot';
export const SUPPORT_TELEGRAM_BOT_URL: string = `https://t.me/${SUPPORT_TELEGRAM_BOT_USERNAME}`;
export const SUPPORT_TELEGRAM_BOT_TG_SCHEME_URL: string = `tg://resolve?domain=${SUPPORT_TELEGRAM_BOT_USERNAME}`;
/** Беседа поддержки во ВКонтакте без кода: запасной адрес, когда ссылку с кодом выдать не удалось. */
export const SUPPORT_VK_CHAT_URL = 'https://vk.ru/im?sel=-237472926';
